"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAbsolutePosition = void 0;
function getAbsolutePosition(el) {
    try {
        if (el) {
            var rect = el.getBoundingClientRect();
            return {
                left: rect.left,
                top: rect.top,
                right: rect.right,
                bottom: rect.bottom,
            };
        }
        return {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
        };
    }
    catch (_a) {
        return {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
        };
    }
}
exports.getAbsolutePosition = getAbsolutePosition;
//# sourceMappingURL=position.js.map